var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5708 0.532532L7.70711 11.3963C7.31658 11.7868 7.31658 12.42 7.70711 12.8105L8.86419 13.9676C9.25472 14.3581 9.88788 14.3581 10.2784 13.9676L18.0383 6.20766V27C18.0383 27.5523 18.486 28 19.0383 28H20.6747C21.227 28 21.6747 27.5523 21.6747 27V6.20766L29.4346 13.9676C29.8251 14.3581 30.4583 14.3581 30.8488 13.9676L32.0059 12.8105C32.3964 12.42 32.3964 11.7868 32.0059 11.3963L21.1421 0.532532C20.4321 -0.177511 19.2809 -0.177511 18.5708 0.532532ZM5.12617 15.3914C5.0023 15.2675 4.88687 15.1384 4.77989 15.0048C2.1206 15.1199 0 17.3123 0 20V35C0 37.7614 2.23858 40 5 40H35C37.7614 40 40 37.7614 40 35V20C40 17.2386 37.7614 15 35 15H34.9369C34.8288 15.1354 34.7122 15.2661 34.5868 15.3914L33.4297 16.5485C31.6138 18.3644 28.6696 18.3644 26.8536 16.5485L25.3247 15.0195L25.3247 27C25.3247 29.5681 23.2428 31.65 20.6747 31.65H19.0383C16.4702 31.65 14.3883 29.5681 14.3883 27V15.0195L12.8593 16.5485C11.0434 18.3644 8.09919 18.3644 6.28326 16.5485L5.12617 15.3914Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon_Upload.c06459ea990c44643a678762b4780320.svg";
export { ForwardRef as ReactComponent };